var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}]},[_c('div',{staticClass:"acvitity_foot",on:{"click":_vm.consultingClick}},[_vm._m(0)]),_c('BranchChat',{ref:"branch",on:{"hideChat":_vm.hideChat}})],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._v("立即咨询"),_c('span',[_vm._v("(享课程优惠)")])])
}]

export { render, staticRenderFns }